import React, { useEffect } from 'react';
import Grid from '@mui/material/Grid';
import TextField from '@mui/material/TextField';
import Button from '@mui/material/Button';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import Typography from '@mui/material/Typography';
import { NavLink, useLocation } from 'react-router-dom';
import NextButton from './components/NextButton';
import PaymentMethodCard from './components/PaymentMethodCard';
import { firePartnerConversionPixel } from '../adSource';

const publicURL = 'https://bucketlistguitars.com/wp-content/reactpress/apps/blg-react-sell/build/assets/';

function ConfirmationPage() {
  const location = useLocation();

  // Trade Into Cash conversion pixel. This MUST live here rather than in the
  // WordPress site header, which is the placement their setup email recommends
  // as the "easy" option. The sell flow is a single-page app: reaching
  // /sell/checkout/success is a client-side route change, so no page load ever
  // occurs with that pathname and a header-level script would never fire. A
  // hard request to that URL 404s at WordPress, confirmed against production.
  // Order detail arrives as router state from the submit handler. If someone
  // lands here without it the pixel still fires with the click id alone, which
  // is what shipped before and is better than reporting no conversion at all.
  const partnerOrder = location.state?.partnerOrder;

  useEffect(() => {
    firePartnerConversionPixel(partnerOrder);
    // Deliberately mount-only. Re-firing on a state change would report the
    // same order twice, and the click id is cleared after the first send.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className="checkout-page" style={{ textAlign: 'center' }}>
      <Grid>
          <Typography gutterBottom variant="h5">
              Thank You For Your Order!
          </Typography>
            <Typography variant="body2" color="textSecondary" component="p" gutterBottom>
              You will receive an email shortly with next steps.
          </Typography>
          <img src={publicURL + 'check.png'} style={{ margin: 'auto', display: 'block', width: 80, marginTop: 48 }}/>
      </Grid>
    </div>
  );
}

export default ConfirmationPage;
